// extracted by mini-css-extract-plugin
export default {"claim_all":"all_claims_claim_all__dUuTS","btn_all_claims":"all_claims_btn_all_claims__JfVeC","loader":"all_claims_loader__+lr-B","rotate":"all_claims_rotate__D+a3M"};